export default "__VITE_ASSET__BU2ZayLN__"